
export class ConfirmModel {
    constructor(
        public message?: string, 
        public title?: string,
        public icon?: string,
        public btnConfirm?: string, 
        public btnDismiss?: string, 
    ) { }
}